<template>
	<li
		class="post_tile"
		@mouseover="hover = true"
		@mouseleave="hover = false"
		:class="[this.background_colour, this.mode]"
	>
		<div
			v-if='video && video.video_url != "" || video && video.video_file != ""'
			class="tile-image"
			:style="{
        '--gallery-background': 'url(' + image + ')',
      }"
			:class="{
        hover: hover === true,
      }"
		>
			<video-modal
				v-if='video && video.video_url != "" || video && video.video_file != ""'
				:has_border="'no'"
				:video_poster="image"
				:video_source="(video.video_url || video.video_file) ? (video.video_url || video.video_file.url) : false"
			></video-modal>

			<div
				class="tag_container"
				v-if="tag && tag.some((e) => e.slug != 'uncategorised') || tag && tag.some((e) => e.slug != 'all')"
			>
				<label
					v-for="(tag_item, index) in tag.filter(tag => tag.slug !== 'all')"
					:key="index"
					:class="tag_item.slug"
					v-html="tag_item.name != 'Uncategorised' || tag_item.name != 'All' ? tag_item.name : null"
				></label>
			</div>
		</div>

		<a
			v-else
			:href="this.mode == 'content' ? null : extractUrl(permalink)"
			class="tile-image"
			:style="{
        '--gallery-background': 'url(' + image + ')',
      }"
			:class="{
        hover: hover === true,
				fallback: !image
      }"
		>
			<img
				v-if='image'
				:src="image"
				:alt="name"
			/>
			<div
				class="tag_container"
				v-if="tag && tag.some((e) => e.slug != 'uncategorised') || tag && tag.some((e) => e.slug != 'all')"
			>
				<h5
					v-for="(tag_item, index) in tag.filter(tag => tag.slug !== 'all')"
					:key="index"
					:class="tag_item.slug"
					v-html="tag_item.name != 'Uncategorised' || tag_item.name != 'All' ? tag_item.name : null"
				></h5>
			</div>
		</a>

		<a
			:href="this.mode == 'content' ? null : extractUrl(permalink)"
			class="content"
		>
			<div class="upper">
				<h4 v-html="name"></h4>
				<span
					class="subtitle"
					v-html="short_description"
				></span>
			</div>
			<div class="lower">
				<tertiary-button
					:label="'Read More'"
					:link="permalink"
				></tertiary-button>
			</div>
		</a>
		<slot></slot>
	</li>
</template>

<script>
import Arrow from '../../images/arrow-long.svg';
// import SecondaryButton from './SecondaryButton.vue';
import FallBack from '../../images/device.svg';
import TertiaryButton from './TertiaryButton.vue';
import VideoModal from './VideoModal.vue';

export default {
	data() {
		return {
			hover: false,
			arrow: Arrow,
			fallBack: FallBack,
		};
	},

	props: {
		name: {},
		permalink: {},
		short_description: {},
		image: {},
		tag: {},
		background_colour: {
			default: 'light-stone',
		},
		mode: {
			default: 'news',
		},
		arrow_colour: {
			default: 'gold',
		},
		index: {},
		video: {},
		post_type: {},
	},

	computed: {},

	watch: {},

	methods: {
		toTitleCase(str) {
			return str.replace(/-/g, ' ').replace(/\w\S*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		},

		extractUrl(permalink) {
			if (typeof permalink === 'string') {
				// Check if it's a non-empty string
				return permalink !== '' ? permalink : null;
			} else if (typeof permalink === 'object' && permalink !== null) {
				// Check if it's an object with a 'url' property
				return permalink.url || null;
			} else {
				// Handle other cases or return a default value as needed
				return null;
			}
		},
	},

	components: {
		// SecondaryButton,
		VideoModal,
		TertiaryButton,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.post_tile {
	overflow: hidden;
	grid-column: span 3;
	display: grid;
	grid-template-rows: auto 1fr;
	position: relative;

	@media (max-width: $tablet) and (orientation: portrait) {
		grid-column: span 3;
	}

	@media (max-width: $mobile-xl) {
		grid-column: span 4;
		/* grid-template-rows: auto 1fr;
		display: flex; */
	}

	&.post,
	&.page {
		a {
			&.tile-image {
				aspect-ratio: 282 / 186;

				@media (max-width: $mobile-xl) {
					aspect-ratio: 312 / 250;
				}
			}
		}
	}

	/* &.featured_post {
		.site_button_secondary {
			&::v-deep {
				span {
					display: none;
				}
			}
		}
	} */

	a,
	div {
		&.tile-image {
			display: flex;
			/* aspect-ratio: 300 / 250; */
			overflow: hidden;
			transition: 0.2s ease all;
			position: relative;
			text-decoration: none;
			/* border: var(--border); */

			&.fallback {
				background: var(--cobalt);
				aspect-ratio: 281 / 159;
			}

			@media (max-width: $mobile) {
				height: auto;
			}

			.video {
				aspect-ratio: 3 / 2;
			}

			&.hover {
				img:not(.page) {
					transition: 0.2s ease all;
					transform: scale(1.1);
				}
			}

			> span {
				width: 100%;
			}

			img:not(.page) {
				width: 100%;
				height: 100%;
				object-fit: cover;
				position: relative;
				transition: 0.2s ease all;
				transform: scale(1);
				aspect-ratio: 281 / 159;
			}

			.tag_container {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				position: relative;
				z-index: 10;
				position: absolute;
				bottom: 16px;
				right: 16px;
				margin: 0;
				gap: 7px;
				justify-content: flex-end;

				h5 {
					font: normal normal bold 12px/14px var(--primary-font-family);
					background: var(--emerald);
					color: var(--midnight);
					border-radius: 15px;
					text-decoration: none;
					padding: 5px 10px;
					height: fit-content;
					margin: 0;

					@media (max-width: $mobile-xl) {
						margin-bottom: 0;
					}
				}
			}

			/* &.page {
				justify-content: center;
				align-items: center;
				background: var(--pip-blue);

				&:hover {
					img {
						width: 120px;
						transition: 0.2s ease all;
					}
				}

				
			} */

			/* img {
				width: 100px;
				height: auto;
				transition: 0.2s ease all;

				&.fallback {
					object-fit: contain;
					width: 200px;
					opacity: 0.3;
				}
			} */
		}
	}

	.content {
		padding: 24px 0;
		background-color: transparent;
		transition: 0.2s ease all;
		height: calc(100% - 48px);
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		row-gap: 24px;
		text-decoration: none;
		color: var(--midnight);
		/* border-radius: 0px 0px 15px 15px; */
		overflow: hidden;
		/* border-left: var(--border);
		border-bottom: var(--border);
		border-right: var(--border); */

		@media (max-width: $mobile-xl) {
			height: unset;
		}

		.upper {
			width: 100%;

			h4 {
				/* font: normal normal 600 18px/24px var(--primary-font-family); */
				margin: 0 0 10px;
			}

			.subtitle {
				margin: 0;
				font: normal normal normal 15px/20px var(--primary-font-family);
				display: -webkit-box;
				-webkit-line-clamp: 3;
				line-clamp: 3;
				-webkit-box-orient: vertical;
				overflow: hidden;

				&::v-deep {
					p {
						margin: 0;
						font: normal normal normal 15px/20px var(--primary-font-family);
					}
				}
			}
		}

		.lower {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;

			.site_button_secondary {
				&::v-deep {
					&:hover {
						cursor: pointer;
					}
				}
			}

			.attributes {
				display: flex;
				flex-direction: row;
				align-items: center;
				gap: 5px;
				text-transform: uppercase;
			}

			a {
				color: var(--bright-blue);
			}
		}
	}

	/* &.nexty {
		.content {
			.lower {
				.site_button_secondary {
					pointer-events: none;

					&::v-deep {
						&:hover {
							cursor: unset;
							span {
								text-decoration: none;
							}
						}
					}
				}
			}
		}
	} */
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>
